__turbopack_context__.v({
  "card": "uIGeEq_card",
  "copy": "uIGeEq_copy",
  "count": "uIGeEq_count",
  "label": "uIGeEq_label",
  "photo": "uIGeEq_photo",
  "section": "uIGeEq_section",
});
